var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { useGlobalDispatch } from '../../hooks';
import { GlobalModals } from './Header';
export function SupportMenu(props) {
    var closeDropDown = props.closeDropDown;
    var globalDispatch = useGlobalDispatch();
    var supportItems = [
        {
            label: 'About',
            callBack: function () {
                globalDispatch({
                    type: 'set modal active',
                    payload: { modal: GlobalModals.About },
                });
            },
        },
        // {
        //   label: 'Help',
        //   callBack: () => {
        //     globalDispatch({
        //       type: 'set modal active',
        //       payload: { modal: GlobalModals.Help },
        //     });
        //   },
        // },
        {
            label: 'Learning',
            callBack: function () {
                globalDispatch({
                    type: 'set modal active',
                    payload: { modal: GlobalModals.Learning },
                });
            },
        },
        {
            label: 'Support',
            callBack: function () {
                globalDispatch({
                    type: 'set modal active',
                    payload: { modal: GlobalModals.Support },
                });
            },
        },
        {
            label: 'Watch World IPS Video',
            divider: true,
            callBack: function () {
                globalDispatch({
                    type: 'set modal active',
                    payload: { modal: GlobalModals.IpsVideo },
                });
            },
        },
        // {
        //   label: 'Send Feedback',
        //   divider: true,
        //   callBack: () => {
        //     globalDispatch({
        //       type: 'set modal active',
        //       payload: { modal: GlobalModals.Feedback },
        //     });
        //   },
        // },
    ];
    return (_jsx(Container, { children: supportItems.map(function (item, index) { return (_jsx(SupportItem, __assign({ closeDropDown: closeDropDown }, item), index)); }) }, void 0));
}
function SupportItem(_a) {
    var label = _a.label, href = _a.href, callBack = _a.callBack, _b = _a.divider, divider = _b === void 0 ? false : _b, closeDropDown = _a.closeDropDown;
    var globalDispatch = useGlobalDispatch();
    function handleCallBack(event) {
        closeDropDown();
        // event.preventDefault()
        if (callBack)
            callBack();
    }
    if (href)
        return (_jsx(Link, __assign({ divider: divider }, { children: _jsx("a", __assign({ href: href, target: '_blank', rel: 'noreferrer noopener' }, { children: label }), void 0) }), void 0));
    else if (callBack || name)
        return (_jsx(Link, __assign({ divider: divider }, { children: _jsx("a", __assign({ onClick: handleCallBack }, { children: label }), void 0) }), void 0));
    return null;
}
var Link = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 48px;\n  font-size: 14px;\n  ", "\n  display: flex;\n  align-items: center;\n  z-index: 1000;\n  a {\n    text-decoration: none;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    height: 32px;\n    padding: 0 24px;\n    color: #656668;\n    transition: 0.3s;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.08);\n    }\n  }\n"], ["\n  height: 48px;\n  font-size: 14px;\n  ", "\n  display: flex;\n  align-items: center;\n  z-index: 1000;\n  a {\n    text-decoration: none;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    height: 32px;\n    padding: 0 24px;\n    color: #656668;\n    transition: 0.3s;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.08);\n    }\n  }\n"])), function (_a) {
    var divider = _a.divider;
    return (divider ? 'border-top: 1px solid #e0e0e0;' : '');
});
var Container = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n  width: 280px;\n  /* margin-bottom: 16px; */\n"], ["\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n  width: 280px;\n  /* margin-bottom: 16px; */\n"])));
var templateObject_1, templateObject_2;
